import Model, { attr, belongsTo } from '@ember-data/model';
import { isPast } from 'date-fns/isPast';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum SecurityDepositStatus {
  authorized = 'authorized',
  collected = 'collected',
  overridden = 'overridden',
  failed = 'failed',
  failing = 'failing',
  needsPaymentInformation = 'needs_payment_information',
  hasPaymentInformation = 'has_payment_information',
}

export default class SecurityDepositModel extends Model {
  @attr('number') amount!: number;
  @attr('string') status!: SecurityDepositStatus;
  @attr('number') remindersSent!: number;
  @attr('string') stripeError!: string;
  @attr('date') releasedAt!: Date;
  @attr('date') chargedAt!: Date;
  @attr('date') expiresAt!: Date;

  @belongsTo('booking', {
    inverse: 'securityDeposit',
    async: false,
  })
  booking!: ModelRegistry['booking'];

  get isAuthorized(): boolean {
    return this.status === SecurityDepositStatus.authorized;
  }

  get isReleased(): boolean {
    return !!this.releasedAt;
  }

  get isExpired(): boolean {
    return (
      this.isAuthorized &&
      !this.isReleased &&
      !!this.expiresAt &&
      isPast(this.expiresAt)
    );
  }

  get isSettleable(): boolean {
    return this.isAuthorized && !this.isReleased && !this.isExpired;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'security-deposit': SecurityDepositModel;
  }
}
